import { jsx } from "react/jsx-runtime";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { validateTidalLicense } from "../../base/index.js";
function DragIndicator(props) {
  return /* @__PURE__ */ jsx(
    DragIndicatorIcon,
    {
      "data-testid": "DragIndicator",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "DragIndicator",
      "data-tidal-icon-meta": "layout"
    }
  );
}
DragIndicator.tidalIconMeta = {
  categories: "layout",
  name: "DragIndicator"
};
validateTidalLicense();
export {
  DragIndicator
};
//# sourceMappingURL=DragIndicator.js.map
